import { render, staticRenderFns } from "./EventPanel.vue?vue&type=template&id=5a1a5e1e&scoped=true&"
import script from "./EventPanel.vue?vue&type=script&lang=js&"
export * from "./EventPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a5e1e",
  null
  
)

export default component.exports